import { Skeleton } from '@mui/material';
import { COLORS, borderRadiusSm } from 'assets/styled';
import { respondTo } from 'assets/styled/breakpoints';
import styled from 'styled-components';
import { css } from 'styled-components';

export const MODEL_CARD_CONTAINER_HEIGHT = 285;
export const MODEL_CARD_CONTAINER_WIDTH = 300;

interface StyledProps {
  opacityIndex: number;
  opacityCoefficient: number;
  imageLoaded: boolean;
}

export const Container = styled.div`
  border: 1px solid ${COLORS.BORDER};
  border-radius: ${borderRadiusSm};
  width: ${MODEL_CARD_CONTAINER_WIDTH}rem;
  height: ${MODEL_CARD_CONTAINER_HEIGHT}rem;
  position: relative;
  display: flex;
  flex-direction: column;
  ${(props: StyledProps) =>
    props.opacityIndex !== undefined &&
    css`
      opacity: ${1 - (props.opacityIndex * props.opacityCoefficient + 0.2)};
    `}

  ${respondTo.smallLaptop`
    max-width: 300rem;
    width: 100%;
    height: 315rem;
  `}

  ${respondTo.horizontalTablet`
    max-width: 100%;
  `}

  ${respondTo.bigPhone`
    max-width: 100%;
    height: auto;
    margin-bottom: 20rem;
  `}
`;

export const OneRow = styled.label`
  line-height: 32rem;
  width: 100%;

  ${respondTo.smallLaptop`
    line-height: 28rem;
  `}
`;

export const RowCenter = styled.div`
  padding: 0 10rem;
  margin-top: 5rem;
`;

export const SplitRow = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledSkeleton = styled(Skeleton)`
  border-radius: ${borderRadiusSm};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  margin-bottom: 10rem;
`;
